// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__10XHk","left":"About_left__2kkxE","right":"About_right__3QgNB"};